module.exports = __webpack_public_path__ + "img/snakerescuers.787186ec.png";